// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKlId35mBMkn3EhPjG3aaIlQSCcZonRug",
  authDomain: "task-manager-2814b.firebaseapp.com",
  projectId: "task-manager-2814b",
  storageBucket: "task-manager-2814b.appspot.com",
  messagingSenderId: "94873546639",
  appId: "1:94873546639:web:77b039e18761072cb665fa",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
